/** 점포 목록·계약서 관리 공통 검색 (name, tljNo, 주소, 담당자, 연락처) */
export function matchStoreSearch(store, query) {
  const q = (query || '').toLowerCase().trim();
  if (!q) return true;

  const qDigits = query.replace(/\D/g, '');
  const phones = [store.storePhone, store.ownerPhone, store.managerPhone, store.hqManagerPhone].filter(Boolean);
  const phoneMatch =
    qDigits.length >= 3 &&
    phones.some((p) => (p || '').replace(/\D/g, '').includes(qDigits));

  const statusLabel = {
    none: '미발송',
    sent: '발송됨',
    signed: '서명 완료',
    expired: '만료',
    renewal_pending: '갱신 대기',
  }[store.contractStatus || 'none'] || '';

  const haystack = [
    store.name,
    store.tljNo,
    store.ownerName,
    store.managerName,
    store.ownerEmail,
    store.contractStatus,
    statusLabel,
    [store.address1, store.address2, store.town, store.state, store.zipcode, store.address]
      .filter(Boolean)
      .join(' '),
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

  return haystack.includes(q) || phoneMatch;
}
